import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import styles from 'src/components/layout/landlord/NavigationLink.module.css';

type Props = {
    text?: string;
    icon: React.ReactNode;
    link?: string;
    onClick: () => void;
};

export default function NavigationLink({
    text,
    icon,
    link,
    onClick,
}: Props) {
    const navigate = useNavigate();
    const location = useLocation();

    const isSelected = !!link && location.pathname.includes(link);
    const bgcolor = isSelected ? 'primary.50' : 'invalid';
    const color = isSelected ? 'primary.main' : 'invalid';

    const handleClick = () => {
        onClick();

        if (link) {
            navigate(link);
        }
    };

    return (
        <>
            <ListItem key={text} disablePadding data-testid={`${text}-link`}>
                <ListItemButton className={styles.button} onClick={handleClick} sx={{ bgcolor }}>
                    <ListItemIcon sx={{ color, minWidth: 0, marginRight: 1 }}>{icon}</ListItemIcon>
                    {!!text && <ListItemText secondary={text} sx={{ color }} />}
                </ListItemButton>
            </ListItem>
        </>
    );
}